/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_ServicesInputs */

const et_nav_services = /** @type {(inputs: Nav_ServicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teenused`)
};

const en_nav_services = /** @type {(inputs: Nav_ServicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Services`)
};

/**
* | output |
* | --- |
* | "Services" |
*
* @param {Nav_ServicesInputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const nav_services = /** @type {((inputs?: Nav_ServicesInputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_ServicesInputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_nav_services(inputs)
	return en_nav_services(inputs)
});